var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("nav.logout")))]),
    _vm._v(" "),
    _c("span", { staticClass: "error", attrs: { show: _vm.error } }, [
      _vm._v(_vm._s(_vm.errorMessage)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }